module.exports = __webpack_public_path__ + "static/media/excel.ef9f960e.svg";